/**
 * Validate if a string is a valid UUID format.
 *
 * @param uuid The string to validate
 * @returns true if the string is a valid UUID format
 */
export function isValidUUID(uuid: string): boolean {
  // UUID format: 8-4-4-4-12 hex characters
  const parts = uuid.toLowerCase().split("-");
  if (parts.length !== 5) return false;
  if (parts[0]?.length !== 8) return false;
  if (parts[1]?.length !== 4) return false;
  if (parts[2]?.length !== 4) return false;
  if (parts[3]?.length !== 4) return false;
  if (parts[4]?.length !== 12) return false;

  // Check all characters are valid hex
  const hexPattern = /^[0-9a-f]+$/;
  return parts.every((part) => hexPattern.test(part));
}
